import { Box, Tooltip } from '@mui/material';
import { ActionButton } from './actionButton';

export interface ButtonConfig {
  renderIcon: () => JSX.Element;
  onClick: (selectedRowIds: Array<number | string>) => void;
  shouldBeDisabled?: (selectedRowIds: Array<number | string>) => boolean;
  tooltip?: string;
}

type Props = {
  config: Array<ButtonConfig>;
  selectedRowIds: Array<number | string>;
};

export type ActionButtonListProps = Props;

export function ActionButtonList({ config, selectedRowIds }: Props): JSX.Element {
  return (
    <Box
      sx={{
        height: '24px',
        '& span > button': {
          backgroundColor: 'unset !important'
        },
        '& span > button:hover > svg': {
          color: 'grey.900'
        }
      }}
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
    >
      {config.map((button, index) => (
        <Tooltip key={index} title={button.tooltip ?? ''}>
          <span>
            <ActionButton
              key={index}
              color="primary"
              size="small"
              onClick={() => button.onClick(selectedRowIds)}
              disabled={button.shouldBeDisabled?.(selectedRowIds)}
            >
              {button.renderIcon()}
            </ActionButton>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
}
